import { Box, Stack, SxProps, Theme, Typography } from "@mui/material";
import React from "react";
import {
  MESSAGING_ERROR,
  MESSAGING_SUCCESS,
  MESSAGING_WARNING,
  WYND_WHITE,
} from "src/styles";

const getLifeLabel = (life: number) => {
  if (life < 0.1) {
    return "Low";
  }
  if (life < 0.4) {
    return "Medium";
  }
  return "Good";
};

const getLifeColor = (life: number) => {
  if (life < 0.1) {
    return MESSAGING_ERROR;
  }
  if (life < 0.4) {
    return MESSAGING_WARNING;
  }
  return MESSAGING_SUCCESS;
};

function FilterLife({
  life, // 0 - 1 (0% - 100%)
  sx,
}: {
  life: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <Stack direction="column" gap={1} sx={sx} alignItems="flex-end">
      <Typography variant="body2">
        Filter Life: {`(${getLifeLabel(life)})`}
      </Typography>
      <Stack
        direction="row"
        sx={{
          width: "100%",
          height: "4px",
          backgroundColor: WYND_WHITE,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            width: `${life * 100}%`,
            backgroundColor: getLifeColor(life),
            borderRadius: "4px",
          }}
        />
      </Stack>
    </Stack>
  );
}

export default FilterLife;
